import { notifications } from "@mantine/notifications";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";
import { clinicQKeys } from "@hooks/queries/clinic/queryKeys";

import { Partner, PracticeType } from "@customTypes/partner";

export interface CreatePartnerPayload {
  name: string;
  enterprise_id?: string;
  is_organization: boolean;
  practice_type: PracticeType;
  description?: string;
  contact_email?: string;
  contact_phone?: string;
  address?: string;
  city?: string;
  country?: string;
  registration_number?: string;
  tax_id?: string;
  is_active?: boolean;
}

export const useCreatePartner = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: async (payload: CreatePartnerPayload) => {
      const { data } = await api.post<Partner>("partners/", payload);
      return data;
    },
    onSuccess: () => {
      notifications.show({
        title: "Success",
        message: "Partner created successfully",
        color: "green",
      });
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.partners(),
      });
    },
    onError: (res: any) => {
      console.error("[From Create Partner Mutation]", res);
      handleErrors(res, "mutation");
    },
  });
};
